/**
 * Create the tabs for the ink and toner finder
 */
(() => {
  const inkTonerContainer = document.querySelector('.ink-and-toner-finder__container');
  if (!inkTonerContainer) return;

  // Create the tabs div
  const tabsWrapper = document.createElement('div');
  tabsWrapper.classList.add('ink-and-toner-finder__tabs');
  inkTonerContainer.appendChild(tabsWrapper);

  // Create the tabs header and add the links
  const tabsHeader = document.createElement('div');
  tabsHeader.classList.add('ink-toner-tabs-header');
  tabsWrapper.appendChild(tabsHeader);

  const selectPrinterModel = document.createElement('a');
  selectPrinterModel.href = 'javascript:;';
  selectPrinterModel.textContent = 'Select Printer Model';
  selectPrinterModel.classList.add('select-print-model', 'active');
  tabsHeader.appendChild(selectPrinterModel);

  const searchByKeyword = document.createElement('a');
  searchByKeyword.href = 'javascript:;';
  searchByKeyword.textContent = 'Search by Keyword';
  searchByKeyword.classList.add('search-by-keyword');
  tabsHeader.appendChild(searchByKeyword);

  // Create the tabs content
  const tabsContent = document.createElement('div');
  tabsContent.classList.add('ink-toner-tabs-content');
  tabsWrapper.appendChild(tabsContent);

  // Move the inktonerfinder_container to the tabs content
  const inkTonerForm = document.querySelector('.inkselectform');
  if (inkTonerForm) {
    inkTonerForm.classList.add('active'); // Add 'active' class by default
    tabsContent.appendChild(inkTonerForm);
  }

  // Create the search by keyword div and content
  const searchByKeywordWrapper = document.createElement('div');
  searchByKeywordWrapper.classList.add('search-by-keyword-wrapper');
  tabsContent.appendChild(searchByKeywordWrapper);

  const searchbar = document.querySelector('.widgetsearch.search').cloneNode(true);
  if (!searchbar) return;
  searchByKeywordWrapper.append(searchbar);

  const input = searchbar.querySelector('input.form-control');
  input.placeholder = 'Search the site...';

  // When clicking on the element, show the correct content
  function showContent(elementsToShow, elementsToHide) {
    elementsToShow.forEach((element) => {
      element.classList.add('active');
    });

    elementsToHide.forEach((element) => {
      element.classList.remove('active');
    });
  }

  selectPrinterModel.addEventListener('click', () => {
    showContent([selectPrinterModel, inkTonerForm], [searchByKeyword, searchByKeywordWrapper]);
  });

  searchByKeyword.addEventListener('click', () => {
    showContent([searchByKeyword, searchByKeywordWrapper], [selectPrinterModel, inkTonerForm]);
  });
})();
